export default {
  water: {
    chapter: '1',
    component: 'helmi-section',
    props: {
      label: 'Käyttövesi',
    },
    children: {
      water_1: {
        chapter: '1.1',
        component: 'helmi-checkbox',
        container: {
          cols: 12,
          md: 6,
        },
        props: {
          label: 'Kunnan',
        },
        value: 'Ei',
      },
      water_2: {
        chapter: '1.2',
        component: 'helmi-checkbox',
        container: {
          cols: 12,
          md: 6,
        },
        props: {
          label: 'Kaivo',
        },
        value: 'Ei',
      },
      water_3: {
        chapter: '1.3',
        component: 'helmi-checkbox',
        container: {
          cols: 12,
          md: 6,
        },
        props: {
          label: 'Porakaivo',
        },
        value: 'Ei',
      },
      water_4: {
        chapter: '1.4',
        component: 'helmi-checkbox',
        container: {
          cols: 12,
          md: 6,
        },
        props: {
          label: 'Muu',
        },
        value: 'Ei',
      },
      water_5: {
        chapter: '1.5',
        component: 'helmi-checkbox',
        container: {
          cols: 12,
          md: 6,
        },
        props: {
          label: 'Vesiosuuskunnan osakas',
        },
        value: 'Ei',
      },
    },
  },

  sewage: {
    chapter: '2',
    component: 'helmi-section',
    props: {
      label: 'Jätevesihuolto',
    },
    children: {
      sewage_1: {
        chapter: '2.1',
        component: 'helmi-checkbox',
        container: {
          cols: 12,
          md: 6,
        },
        props: {
          label: 'Kunnan',
        },
        value: 'Ei',
      },
      sewage_2: {
        chapter: '2.2',
        component: 'helmi-checkbox',
        container: {
          cols: 12,
          md: 6,
        },
        props: {
          label: 'Umpisäiliö',
        },
        value: 'Ei',
      },
      sewage_3: {
        chapter: '2.3',
        component: 'helmi-checkbox',
        container: {
          cols: 12,
          md: 6,
        },
        props: {
          label: 'Saostuskaivo',
        },
        value: 'Ei',
      },
      sewage_4: {
        chapter: '2.4',
        component: 'helmi-checkbox',
        container: {
          cols: 12,
          md: 6,
        },
        props: {
          label: 'Maahanimeyttämö',
        },
        value: 'Ei',
      },
      sewage_5: {
        chapter: '2.5',
        component: 'helmi-checkbox',
        container: {
          cols: 12,
          md: 6,
        },
        props: {
          label: 'Maasuodattamo',
        },
        value: 'Ei',
      },
      sewage_6: {
        chapter: '2.6',
        component: 'helmi-checkbox',
        container: {
          cols: 12,
          md: 6,
        },
        props: {
          label: 'Selvitys',
        },
        value: 'Ei',
      },
      sewage_7: {
        chapter: '2.7',
        component: 'helmi-checkbox',
        container: {
          cols: 12,
          md: 6,
        },
        props: {
          label: 'Pienpuhdistamo',
        },
        value: 'Ei',
      },
      sewage_8: {
        chapter: '2.8',
        component: 'helmi-checkbox',
        container: {
          cols: 12,
          md: 6,
        },
        props: {
          label: 'Suunnitelma',
        },
        value: 'Ei',
      },
      sewage_9: {
        chapter: '2.9',
        component: 'helmi-checkbox',
        container: {
          cols: 12,
          md: 6,
        },
        props: {
          label: 'Käyttö- ja huolto-ohjeet',
        },
        value: 'Ei',
      },
    },
  },
  roads: {
    chapter: '3',
    component: 'helmi-section',
    props: {
      label: 'Tiestö',
    },
    children: {
      roads_1: {
        chapter: '3.1',
        component: 'helmi-checkbox',
        container: {
          cols: 12,
          md: 6,
        },
        props: {
          label: 'Tie perille',
        },
        value: 'Ei',
      },
      roads_2: {
        chapter: '3.2',
        component: 'helmi-text-field',
        container: {
          cols: 12,
        },
        props: {
          label: 'Tiemaksut',
          type: 'text',
        },
        value: null,
      },
    },
  },

  plans: {
    chapter: '4',
    component: 'helmi-section',
    props: {
      label: 'Rakentamiseen, kaavoitukseen tai liikennejärjestelyihin liittyvät suunnitelmat',
    },
    children: {
      plans_1: {
        chapter: '4.1',
        component: 'helmi-text-field',
        container: {
          cols: 12,
        },
        props: {
          label: 'Kohteen tai sen naapurikiinteistöjen tai lähialueen suunnitelmat, viranomaismenettelyt tai vastaavat',
          type: 'text',
        },
        value: null,
      },
    },
  },

  otherBuildings: {
    chapter: '5',
    component: 'helmi-section',
    props: {
      label: 'Muut rakennukset',
    },
    children: {
      otherBuildings_1: {
        chapter: '5.1',
        component: 'helmi-text-field',
        container: {
          cols: 12,
        },
        props: {
          label: 'Muut rakennukset (esim. ulkovarasto, autotalli)',
          type: 'text',
        },
        value: null,
      },
    },
  },

  heating: {
    chapter: '6',
    component: 'helmi-section',
    props: {
      label: 'Lämmitysjärjestelmä',
    },
    children: {
      heating_1: {
        chapter: '6.1',
        component: 'helmi-text-field',
        container: {
          cols: 12,
        },
        props: {
          label: 'Lämmitysjärjestelmän kunto ja lisätiedot',
          type: 'text',
        },
        value: null,
      },
    },
  },

  damage: {
    chapter: '7',
    component: 'helmi-section',
    props: {
      label: 'Viat ja puutteet',
    },
    children: {
      clientKnowsOrSuspects: {
        chapter: '7.1',
        classes: 'text-subtitle-2',
        component: 'helmi-title',
        props: {
          label: 'Toimeksiantaja tietää tai epäilee, että rakennuksessa on',
        },
      },

      waterDamage: {
        chapter: '7.1.1',
        component: 'helmi-radiogroup',
        container: {
          cols: 12,
          md: 6,
        },
        props: {
          label: 'Sattunut vesivahinko',
        },
        options: ['Kyllä', 'Ei'],
        value: null,
      },

      moistureDamage: {
        chapter: '7.1.2',
        component: 'helmi-radiogroup',
        container: {
          cols: 12,
          md: 6,
        },
        props: {
          label: 'Kosteusvaurioita',
        },
        options: ['Kyllä', 'Ei'],
        value: null,
      },

      moldOrFungus: {
        chapter: '7.1.3',
        component: 'helmi-radiogroup',
        container: {
          cols: 12,
          md: 6,
        },
        props: {
          label: 'Home- tai sieniongelma',
        },
        options: ['Kyllä', 'Ei'],
        value: null,
      },

      otherDamageOrDeficiencies: {
        chapter: '7.1.4',
        component: 'helmi-radiogroup',
        container: {
          cols: 12,
          md: 6,
        },
        props: {
          label: 'Muita erityisiä vahinkoja, vikoja tai puutteita',
        },
        options: ['Kyllä', 'Ei'],
        value: null,
      },

      additionalInfoOfTheDeficiencies: {
        chapter: '7.1.5',
        component: 'helmi-textarea',
        container: {
          cols: 12,
        },
        props: {
          hint: 'Vahingon ajankohta, laajuus, syy jne.',
          label: 'Lisätietoja vioista ja puutteista',
        },
        value: null,
      },
    },
  },

  disadvantages: {
    chapter: '7',
    component: 'helmi-section',
    props: {
      label: 'Asumisviihtyvyyteen vaikuttavat tekijät',
    },
    children: {
      disadvantages_1: {
        chapter: '7.1',
        component: 'helmi-text-field',
        container: {
          cols: 12,
        },
        props: {
          label: 'Asumisviihtyvyyteen vaikuttavat tekijät (esim. melu, haju, tärinä, kuumuus, kylmyys, veto, tuhoeläimet, jyrsijät)',
          type: 'text',
        },
        value: null,
      },
    },
  },

  keys: {
    chapter: '8',
    component: 'helmi-section',
    props: {
      label: 'Avaimet',
    },
    children: {
      numberOfKeys: {
        chapter: '8.1',
        component: 'helmi-text-field',
        container: {
          cols: 12,
          md: 6,
        },
        props: {
          label: 'Toimeksiantajan hallussa olevia käyttölukon avaimia',
          suffix: 'kpl',
          type: 'number',
        },
        value: null,
      },

      securityLock: {
        chapter: '8.2',
        component: 'helmi-text-field',
        container: {
          cols: 12,
          md: 6,
        },
        props: {
          label: 'Turvalukon avainten lukumäärä',
          suffix: 'kpl',
          type: 'number',
        },
        value: null,
      },

      otherKeys: {
        chapter: '8.3',
        component: 'helmi-text-field',
        container: {
          cols: 12,
          md: 6,
        },
        props: {
          label: 'Muut avaimet',
          type: 'text',
        },
        value: null,
      },

      agentReceivedKeyData: {
        chapter: '8.4',
        component: 'helmi-date-picker',
        container: {
          cols: 12,
          md: 6,
        },
        props: {
          label: 'Välittäjä vastaanottanut avaimen',
          type: 'text',
          appendIcon: 'today',
        },
        value: null,
      },
    },
  },

  otherImportantInfo: {
    chapter: '9',
    component: 'helmi-section',
    props: {
      label: 'Lisätiedot',
    },
    children: {
      includedInTheDeal: {
        chapter: '9.1',
        component: 'helmi-textarea',
        container: {
          cols: 12,
        },
        props: {
          label: 'Lisätiedot',
        },
        value: null,
      },
    },
  },

  attachments: {
    chapter: '10',
    component: 'helmi-section',
    props: {
      label: 'Liitteet',
    },
    children: {
      attachments_1: {
        chapter: '10.1',
        component: 'helmi-textarea',
        container: {
          cols: 12,
        },
        props: {
          label: 'Liitteet',
        },
        value: null,
      },
    },
  },
};
